import React from 'react';

function OrganizationsPart ({ body, organizations }) {
  return (
    <article className="white-box-bg_content article bli-medlem">
      {body && <div dangerouslySetInnerHTML={{__html: body}} />}
      <div className="support">
            <div className="support-wrap">
              {organizations.map((org) => (
                <div className="support-box" key={org.id}>
                  {org.image && (
                    <div className="support-header">
                      <div className="support-image">
                        <img src={org.image} alt="" />
                      </div>
                    </div>
                  )}
                  <div className="support-body">
                      <div className="support-heading">
                          <h3>{org.title}</h3>
                      </div>
                      {org.intro && (
                        <div className="support-text">
                          <p>{org.intro}</p>
                        </div>
                      )}
                  </div>
                </div>
              ))}
            </div>
        </div>
    </article>
  )
}

export default (props) => <OrganizationsPart {...props} />